import { render, staticRenderFns } from "./LineSeparator.vue?vue&type=template&id=f2371b1e&scoped=true"
import script from "./LineSeparator.vue?vue&type=script&lang=js"
export * from "./LineSeparator.vue?vue&type=script&lang=js"
import style0 from "./LineSeparator.vue?vue&type=style&index=0&id=f2371b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2371b1e",
  null
  
)

export default component.exports